export enum PLAN_LIMITS_LOGIC {
  ALL_REQUIRED = 'all_required',
  AT_LEAST_ONE_REQUIRED = 'at_least_one_required'
}